import { userPermission } from "../../../../utils/userInfo";

export const modifyOptions = (page, status, permissions) => {
  const options = [
    {
      value: "ยกเลิก",
      disabled: userPermission(permissions, "purchase", page, "cancel"),
    },
    {
      value: "คัดลอก",
      disabled: userPermission(permissions, "purchase", page, "create"),
    },
    {
      value: "แก้ไข",
      disabled: userPermission(permissions, "purchase", page, "edit"),
    },
  ];

  const extraOption = [
    {
      value: "บันทึกใบบันทึกซื้อ",
      disabled: userPermission(permissions, "purchase", page, "edit"),
    },
    {
      value: "บันทึกใบเพิ่มหนี้",
      disabled: userPermission(permissions, "purchase", page, "edit"),
    },
    {
      value: "ยกเลิกจำนวนที่ค้าง",
      disabled: userPermission(permissions, "purchase", page, "edit"),
    },
  ];

  if (!status) {
    return options;
  }
  switch (page) {
    case "order":
      switch (status) {
        case "draft":
          return [options[0], options[1]];
        case "waitApprove":
          return options;
        case "notApproved":
          return [options[0], options[1]];
        case "approved":
          return [extraOption[0], ...options];
        case "partiallyImported":
          return [extraOption[0], options[1], extraOption[2]];
        case "fullyImported":
          return [extraOption[0], options[1]];
        case "cancelled":
          return [options[1]];
        default:
          return [];
      }
    case "return":
      switch (status) {
        case "draft":
          return [options[0], options[1]];
        case "waitApprove":
          return options;
        case "notApproved":
          return [options[0], options[1]];
        case "approved":
          return [extraOption[1], options[0], options[1]];
        case "finished":
          return [options[1]];
        case "cancelled":
          return [options[1]];
        default:
          break;
      }
      break;
    default:
      return options;
  }
};
